export default "__VITE_ASSET__BFf1cecK__"